import { confirm } from './imperative'

export async function confirmResetProgress(): Promise<
  'reset' | 'continue' | 'dismissed'
> {
  const confirmed = await confirm({
    title: 'Recomeçar do zero',
    description:
      'Tem certeza que deseja recomeçar do zero? Você perderá todo o progresso atual.',
    variant: 'warning',
    confirmLabel: 'Sim, recomeçar',
    cancelLabel: 'Continuar de onde parei',
    confirmVariant: 'destructive'
  })

  if (confirmed) return 'reset'
  return 'continue'
}
